import React, { useState } from "react";

const Footer = () => {
  const [showCertificate, setShowCertificate] = useState(false);

  return (
    <footer className="bg-white/80 backdrop-blur-sm border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} BuildMyWealth. All rights reserved.{" "}
            <a
              target="_blank"
              href="https://udyamregistration.gov.in/verifyudyambarcode.aspx?verifyudrn=C5m9mFJnaacahCpBqpTjv5KXjeAX3qa+nISpm/Cd8pU="
              class="text-indigo-700 hover:underline"
            >
              Udyam MSME Registration No: UDYAM-UP-43-0146983
            </a>
          </div>
          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/buildmywealth"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-indigo-600 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@BuildMyWealth-2025"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-indigo-600 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a
              href="https://wa.me/919616622620"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-indigo-600 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      {/* Bottom Section with links and disclaimer */}
      <section className="max-w-4xl mx-auto px-4 py-4 text-xs text-gray-500 text-center space-y-2">
        <div>
          <a
            href="/privacy-policy"
            className="underline hover:text-indigo-700 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          {" | "}
          <a
            href="/terms-and-conditions"
            className="underline hover:text-indigo-700 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
        </div>
        <div>
          <strong>SEBI/AMFI Disclaimer:</strong> Mutual Fund investments are
          subject to market risks, read all scheme related documents carefully.
          Mukesh Kumar Singh (ARN-327050) is an AMFI Registered Mutual Fund
          Distributor. We do not provide any assured returns or portfolio
          management services.
        </div>
      </section>
      {/* Disclosure Section */}
      <section className="relative py-6 bg-transparent border-t border-gray-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
            <span className="font-medium text-gray-500">Our platform partners:</span> Mukesh Kumar Singh (BuildMyWealth) collaborates with trusted SEBI-registered platforms like AssetPlus to ensure secure and compliant mutual fund transactions. Your onboarding experience may vary based on regulatory requirements and preferred channels.
            <br />
            <button
              className="mt-2 underline text-indigo-500 hover:text-indigo-700 text-xs font-medium focus:outline-none"
              onClick={() => setShowCertificate(true)}
              type="button"
            >
              Empaneled with AssetPlus – View Certificate
            </button>
          </p>
        </div>
      </section>
      {/* AssetPlus Certificate Modal */}
      {showCertificate && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-4 relative animate-fadeInUp">
            <button
              onClick={() => setShowCertificate(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-indigo-600 text-2xl font-bold px-2"
              aria-label="Close"
              type="button"
            >
              &times;
            </button>
            <div className="text-center mb-2 font-semibold text-indigo-700 text-sm">AssetPlus Empanelment Certificate</div>
            <img
              src="/assets/images/assetplus-certificate.png"
              alt="AssetPlus Certificate"
              className="w-full h-auto rounded shadow border"
              style={{ maxHeight: 350, objectFit: 'contain' }}
            />
            <div className="mt-2 text-xs text-gray-500 text-center">For reference only</div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
